import React, {useState} from 'react';
import Modal from '../UI/modals/Modal';
import TenantsList from './TenantsList';
import AppConstants from '../../Constants/AppConstants';
import {ToastContainer} from 'react-toastify';
import {useLocale} from '../../Localization/LocaleContext';

const TenantChangeButton = ({darkMode = false}) => {
  const [isOpen, setIsOpen] = useState(false);
  const {translate: t} = useLocale();
  return (
    <>
      <button
        className={`flex items-center gap-[6px] px-[8px] py-[6px] text-[12px] whitespace-nowrap ${
          darkMode ? 'text-[#f7f7f7]' : 'text-[#000000]'
        }`}
        onClick={() => setIsOpen(true)}>
        <svg
          width="19px"
          height="19px"
          viewBox="0 0 24 24"
          fill="none"
          xmlns="http://www.w3.org/2000/svg">
          <path
            d="M18 10L21 7M21 7L18 4M21 7H7M6 14L3 17M3 17L6 20M3 17H17"
            stroke={darkMode ? '#6ed19d' : '#146d55'}
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </svg>
        {t('navigation.switch_project', 'Switch Project')}
      </button>

      {isOpen && (
        <Modal onCloseModal={() => setIsOpen(false)}>
          <div className=" max-w-[600px] max-h-[90dvh]  absolute right-0 left-0  md:top-0 bottom-0 mx-auto my-auto w-full h-full grid place-items-start bg-white  backdrop-blur-sm z-50  rounded-md">
            <TenantsList closeModal={() => setIsOpen(false)} />
          </div>
        </Modal>
      )}
    </>
  );
};

export default TenantChangeButton;
